import React from 'react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

export default function Clock({ isPlaying, countdown, onComplete, clockKey }) {
    return (
        <>
            <div className='absolute bottom-20 left-1/2 -translate-x-1/2'>
                {/* DOCS: https://www.npmjs.com/package/react-countdown-circle-timer */}
                <CountdownCircleTimer
                    isPlaying={true}
                    key={clockKey}
                    onComplete={onComplete}
                    strokeLinecap='butt'
                    strokeWidth={5}
                    size={80}
                    duration={countdown}
                    colors={['rgb(132 204 22)']}
                >
                    {({ remainingTime }) => remainingTime}
                </CountdownCircleTimer>
            </div>
        </>

    )
}